import { nextTick } from 'vue';
import { EMAIL_REGEX } from '@deepcloud/field-validators';

export function useCreateStoreHelpers() {
  function compareString(first: string, second: string, insensitive = true) {
    if (!first || !second) {
      return false;
    }
    return insensitive
      ? first.toLowerCase() === second.toLowerCase()
      : first === second;
  }

  function validateEmail(mail: string) {
    return EMAIL_REGEX.test(mail);
  }

  async function focusInputField(inviteeId: string) {
    await nextTick(() => {
      const inviteeElement = window.document.getElementById(
        `email-${inviteeId}`
      );
      if (inviteeElement) {
        inviteeElement.focus();
      }
    });
  }

  function changeEmailAddress(signeeId: string, email: string) {
    const emailFields = document.querySelectorAll<HTMLElement>(
      `[id^="signature-email-${signeeId}-"]`
    );
    emailFields.forEach((emailField) => {
      emailField.innerHTML = email;
    });
  }

  return {
    compareString,
    changeEmailAddress,
    focusInputField,
    validateEmail
  };
}
